export const TRAVEL_PLACEHOLDER_IMAGE = '/images/travel-placeholder.jpg';

export function travelCityLabel(travel) {
  const city = travel?.city;
  if (!city) {
    return travel?.destination || '';
  }
  return city.name_translations?.en || city.name || city.code || travel.destination || '';
}

export function travelAirportLabel(travel) {
  const airport = travel?.airport;
  if (!airport) {
    return travel?.destination || '';
  }
  return airport.name_translations?.en || airport.name || airport.code || travel.destination || '';
}

export function formatPlaceLabel(city, country) {
  if (!city) {
    return '';
  }
  if (!country) {
    return city;
  }
  return `${city}, ${country}`;
}

export function handleTravelImageError(event) {
  const img = event.currentTarget;
  if (!img || img.dataset.fallbackApplied === '1') {
    return;
  }
  img.dataset.fallbackApplied = '1';
  img.src = TRAVEL_PLACEHOLDER_IMAGE;
}

export function isPlaceholderImage(url) {
  return url === TRAVEL_PLACEHOLDER_IMAGE;
}
